import React, { useState } from 'react';
import QuizzGame from '@/features/quiz/QuizzGame';
import { MOCK_QUIZ } from '@/mocks/mockQuiz.js';
import { computeQuizPoints } from '@/utils/quizScoring.js';

const getTier = (points) => {
    if (points >= 1400) return 'Masterclass 🏆';
    if (points >= 800)  return 'Premier de cordée 🎯';
    if (points >= 300)  return 'Titulaire solide ⚽️';
    return 'Niveau Footix 🍿';
};

const styleBlock = (
    <style>{`
    .glass-panel-light {
        background: rgba(255,255,255,0.7); backdrop-filter: blur(24px);
        -webkit-backdrop-filter: blur(24px);
        border: 1px solid rgba(255,255,255,0.9);
        box-shadow: 0 10px 40px rgba(0,0,0,0.05);
    }
    .spring-transition { transition: all 0.5s cubic-bezier(0.34,1.56,0.64,1); }
`}</style>
);

export default function DemoQuizzPage() {
    const [step, setStep] = useState('quiz'); // 'quiz' | 'result'
    const [totalPoints, setTotalPoints] = useState(0);
    const [correctCount, setCorrectCount] = useState(0);

    const handleComplete = (answers) => {
        let pts = 0;
        let correct = 0;
        answers.forEach(({ questionId, chosenChoiceId, timeTakenMs }) => {
            const q = MOCK_QUIZ.questions.find(q => q.id === questionId);
            if (!q || !chosenChoiceId) return;
            if (chosenChoiceId === q._correctChoiceId) {
                correct++;
                pts += computeQuizPoints(q.basePoints, q.timeLimitSec, timeTakenMs);
            }
        });
        setTotalPoints(pts);
        setCorrectCount(correct);
        setStep('result');
    };

    const handleRestart = () => {
        setStep('quiz');
        setTotalPoints(0);
        setCorrectCount(0);
    };

    if (step === 'quiz') {
        return <QuizzGame questions={MOCK_QUIZ.questions} onComplete={handleComplete} />;
    }

    const maxPoints = MOCK_QUIZ.questions.reduce((s, q) => s + q.basePoints * 2, 0);
    const percentage = Math.round((totalPoints / maxPoints) * 100);

    return (
        <div className="fixed inset-0 z-50 bg-[#F8FAFC] font-sans overflow-hidden select-none flex flex-col items-center justify-center px-6 py-12">
            {styleBlock}

            {/* Fond */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute w-[120vw] h-[120vw] md:w-[600px] md:h-[600px] rounded-full blur-[100px] opacity-30 bg-emerald-300" style={{ top: '-10%', left: '-20%' }} />
                <div className="absolute w-[100vw] h-[100vw] md:w-[500px] md:h-[500px] rounded-full blur-[90px] opacity-30 bg-blue-200" style={{ bottom: '-10%', right: '-10%' }} />
            </div>

            <div className="relative z-10 w-full max-w-md mx-auto text-center flex flex-col items-center gap-6">

                {/* Cercle score */}
                <div className="relative w-56 h-56 flex items-center justify-center bg-white rounded-full shadow-[0_20px_50px_rgba(0,0,0,0.06)]">
                    <svg className="absolute inset-0 w-full h-full -rotate-90">
                        <circle cx="112" cy="112" r="96" stroke="#F1F5F9" strokeWidth="10" fill="none" />
                        <circle
                            cx="112" cy="112" r="96"
                            stroke="currentColor" strokeWidth="10" fill="none"
                            strokeDasharray="603"
                            strokeDashoffset={603 - (603 * percentage) / 100}
                            className="text-emerald-500 transition-all duration-1000 ease-out"
                            strokeLinecap="round"
                        />
                    </svg>
                    <div className="flex flex-col items-center z-10">
                        <span className="text-5xl font-black text-gray-900 leading-none tabular-nums">
                            {totalPoints.toLocaleString()}
                        </span>
                        <span className="text-xs font-bold text-gray-400 uppercase tracking-widest mt-1">pts</span>
                    </div>
                </div>

                {/* Tier + sous-titre */}
                <div className="glass-panel-light px-6 py-3 rounded-full">
                    <span className="text-lg font-black text-gray-800 uppercase tracking-wider">
                        {getTier(totalPoints)}
                    </span>
                </div>

                <p className="text-sm font-semibold text-gray-400">
                    {correctCount} / {MOCK_QUIZ.questions.length} bonnes réponses
                </p>

                <button
                    onClick={handleRestart}
                    className="w-full py-5 bg-gray-900 rounded-2xl text-white font-black text-lg uppercase tracking-widest active:scale-95 spring-transition shadow-xl hover:-translate-y-1 hover:shadow-2xl"
                >
                    Retour au Prono
                </button>
            </div>
        </div>
    );
}
